/**
 * cashbook
 */

export const taxationOptions = [
  { text: "通常課税", value: "normal" },
  { text: "課税軽減", value: "reduced" },
  { text: "非課税", value: "none" },
];
